import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5238 2H1.80954C1.17836 2 0.666687 2.51167 0.666687 3.14286V10C0.666687 10.6312 1.17836 11.1429 1.80954 11.1429H11.5238C12.155 11.1429 12.6667 10.6312 12.6667 10V3.14286C12.6667 2.51167 12.155 2 11.5238 2Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66668 8.28575C7.61345 8.28575 8.38096 7.51824 8.38096 6.57146C8.38096 5.62469 7.61345 4.85718 6.66668 4.85718C5.7199 4.85718 4.95239 5.62469 4.95239 6.57146C4.95239 7.51824 5.7199 8.28575 6.66668 8.28575Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.09521 14H14.3809C14.684 14 14.9747 13.8796 15.1891 13.6652C15.4034 13.4509 15.5238 13.1602 15.5238 12.8571V7.14282",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgWallet;
